<template>
    <div class="alerts-list">
        <div class="alert alert-dismissible fade show" role="alert" :class="'alert-' + message.type" v-for="(message, index)  in alerts" v-if="message.show">
            <strong v-if="message.title">{{ message.title}}</strong>
            <p v-html="message.message"></p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"  @click="close(message, index)"></button>
            <button type="button" class="btn btn-sm btn-danger" v-if="message.critical"
                    @click="notify(message, index)">
                send error notification
            </button>
        </div>
    </div>
</template>

<style scoped>
.alerts-list {
    padding: 1rem;
    position: fixed;
    bottom: 0;
    right: 0;
    width: max(25%, 300px);
    opacity: 0.8;
    z-index: 1090;
}

.alert {
    padding: 1rem;
}

.alert p {
    padding-bottom: 0;
    margin-bottom: 0;
}
</style>


<script>

export default {
    props: {
        messages: Array
    },
    data() {
        return {
            //messages: []
        };
    },
    mounted() {

    },
    methods: {
        notify: function (message, index) {
            this.$root.api.post('/admin/api/error', {error: message}).then(response => {
                if (this.checkNoError(response)) {
                    this.alert('Error saved with ID#' + response.data.error_id, 'success');
                }
            });
            this.close(message, index);
        },
        close: function (message, index) {
            message.show = false;
            this.$store.commit('hide_message', index);
        }
    },
    computed: {
        alerts: function () {
            return this.$store.getters.messages;
        }
    }
}
</script>
